import './winner-card.css';

import LocationIcon from '../../../uber-assets/location-icon.svg';
import { SHARE_ICON, INSTA_ICON, INFO_ICON } from '../../../uber-assets/inline-svgs';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useRef, useState } from 'react';
import { CustomDot } from "../carousel/custom-dot";
import { AREAS_BY_ID } from '../../model/areas';

import WinnerRibbon from '../../../uber-assets/ribbon_winner.png';
import WinnerRibbonLastYear from '../../../uber-assets/ribbon_winner_2025.png';
import nl2br from 'react-nl2br';
import { CACHE_BUSTING_VERSION } from '../../model/phases';
// 158*157

export function WinnerCard({ icon, category, winner, infoFunction, instagramFunction, orderFunction, isNarrow, showRibbon, lastYear }) {
    const useImage = winner?.winImage ?? winner.image;
    const hasMultipleImages = Array.isArray(useImage) && useImage.length > 1;
    const isVideo = (media) => /\.(mp4|webm|mov|m4v)(\?.*)?$/i.test(media);
    const cardRef = useRef(null);
    const [playingVideo, setPlayingVideo] = useState(null);

    const playVideo = (event) => {
        event.stopPropagation();
        const video = event.currentTarget.parentElement.querySelector('video');
        if (!video) {
            return;
        }

        video.play().catch(() => {});
    };

    const stopVideos = () => {
        cardRef.current?.querySelectorAll('video').forEach((video) => video.pause());
        setPlayingVideo(null);
    };

    return (
        <div ref={cardRef} className={`winner-card${isNarrow ? ' narrow' : ''} card-anim-start`}>
            {/* <div className="winner-card__top-banner">{icon}<p>{category}</p></div> */}
            <div className='winner-card__content-holder'>
                {!Array.isArray(useImage) &&
                    <div className="winner-card__image" style={{backgroundImage: `url(./img/restaurants/${useImage})`}}></div>
                }
                {Array.isArray(useImage) &&
                    <Carousel
                        swipeable={hasMultipleImages}
                        draggable={hasMultipleImages}
                        showDots={hasMultipleImages}
                        customDot={<CustomDot />}
                        arrows={hasMultipleImages}
                        responsive={{all: {breakpoint:{min: 0, max: 1000000}, items: 1}}}
                        ssr={false} // means to render carousel on server-side.
                        infinite={true}
                        autoPlay={false}
                        autoPlaySpeed={3000}
                        keyBoardControl={false}
                        transitionDuration={500}
                        containerClass="winner-card__carousel"
                        dotListClass=''
                        beforeChange={stopVideos}
                    >
                        {
                            useImage.map((media, index) => {
                                const mediaUrl = `./img/restaurants/${media}?v=${CACHE_BUSTING_VERSION}`;
                                return (
                                    isVideo(media) ?
                                        <div key={index} className="winner-card__video-slide">
                                            <video
                                                className="winner-card__video"
                                                controls
                                                playsInline
                                                preload="metadata"
                                                onPlay={() => setPlayingVideo(index)}
                                                onPause={() => setPlayingVideo(null)}
                                                onEnded={() => setPlayingVideo(null)}
                                            >
                                                <source src={mediaUrl} />
                                            </video>
                                            {playingVideo !== index &&
                                                <button
                                                    type="button"
                                                    className="winner-card__video-control"
                                                    onClick={playVideo}
                                                    aria-label="Play video"
                                                >
                                                    <span aria-hidden="true"></span>
                                                </button>
                                            }
                                        </div> :
                                        <div key={index} className="winner-card__image" style={{backgroundImage: `url(${mediaUrl})`}}></div>
                                )
                            })
                        }
                    </Carousel>
                }
                <div className="winner-card__info">
                
                    <h2 className="winner-card__info__name">{winner.owner || winner.name}</h2>
                    {/* <h3>{winner.restaurant || winner.name}</h3> */}
                    <div className="winner-card__info__location">
                        <img className='small-info-icon' src={LocationIcon} alt='Location icon' />
                        <p>{winner.location || AREAS_BY_ID[winner.region].label}</p>
                    </div>

                    <div className='grow'>
                        <p className="winner-card__info__description">{nl2br(winner?.winnerBlurb ?? winner.description)}</p>
                        <div className='winner-card__read-more' onClick={() => infoFunction(winner)}>Read more</div>
                    </div>
                    
                    <div className="winner-card__info__buttons">
                        {/* <button className="winner-card__info__buttons__info square light" onClick={() => infoFunction(winner)}>{INFO_ICON}</button> */}
                        <button className="winner-card__info__buttons__instagram square light" onClick={() => instagramFunction(winner)}>{INSTA_ICON}</button>
                        <button className="winner-card__info__buttons__order black order-button" onClick={() => orderFunction(winner)}>Order on Uber Eats</button>
                    </div>
                </div>
            </div>
            {showRibbon &&
                <img className='card-ribbon-big' src={lastYear ? WinnerRibbonLastYear : WinnerRibbon} alt='Winner' />
            }
        </div>
    );
}